import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonMenuButton,
  IonIcon,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
} from '@ionic/react';
import { mailOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import GoogleIntegration from '../components/GoogleIntegration';

const EmailConfiguration: React.FC = () => {
  const { t } = useTranslation();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton menu="main-menu" />
          </IonButtons>
          <IonTitle>{t('emailConfig.title', 'Email Configuration')}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
        <div className="max-w-4xl mx-auto p-4">
          <IonCard className="mb-4">
            <IonCardHeader>
              <IonCardTitle className="flex items-center space-x-2">
                <IonIcon icon={mailOutline} className="text-2xl" />
                <span>
                  {t('emailConfig.description', 'Email Integration Settings')}
                </span>
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                {t(
                  'emailConfig.info',
                  'Connect your Gmail accounts to automatically import ticket sales from LiveFootballTickets, StubHub, and Football Ticket Net. The system will monitor your emails and create sales records automatically.'
                )}
              </p>
              <div className="space-y-2 text-sm">
                <h4 className="font-semibold text-gray-700 dark:text-gray-300">
                  {t(
                    'emailConfig.supportedProviders',
                    'Supported Ticket Providers:'
                  )}
                </h4>
                <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1">
                  <li>LiveFootballTickets (sales@livefootballtickets.com)</li>
                  <li>
                    StubHub (order-update@orders.stubhubinternational.com)
                  </li>
                  <li>Football Ticket Net (ftn@footballticketnet.com)</li>
                  <li>Ticombo (info-noreply@ticombo.com)</li>
                  <li>Fanpass (no-reply@fanpass.net)</li>
                  <li>Tixstock (orders@tixstock.com)</li>
                </ul>
              </div>
            </IonCardContent>
          </IonCard>

          {/* Google Integration Component */}
          <GoogleIntegration />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default EmailConfiguration;
